import { openingReplay, validateRecordings } from './recording';
import type { Replay } from './recording';

const files = import.meta.glob<unknown>('./replays/*.json', { eager: true, import: 'default' });

/** Every recording under src/replays, validated as a set. */
export const REPLAYS: readonly Replay[] = validateRecordings(
  Object.entries(files).map(([file, value]) => [file.replace(/^\.\//, 'src/'), value] as const),
);

export const REPLAY_BY_CHIP: ReadonlyMap<string, Replay> = new Map(
  REPLAYS.flatMap((r) => (r.chip === null ? [] : [[r.chip, r] as const])),
);

/** The recording the page opens on; see openingReplay. */
export const OPENING_REPLAY: Replay | null = openingReplay(REPLAYS);
